import {
	BaseError,
} from './BaseError';

export class GetCompanyEstablishmentsError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
